// extracted by mini-css-extract-plugin
export var printerCard = "_bq-1";
export var printerCardConfigured = "_bq-2";
export var printerCardError = "_bq-3";
export var printerCardsContainer = "_bq-0";
export var printerIcon = "_bq-8";
export var printerIconConfigured = "_bq-5";
export var printerIconContainer = "_bq-4";
export var printerIconError = "_bq-6";
export var printerIconUnconfigured = "_bq-7";
export var workstationsTableCard = "_bq-9";